import styled from 'styled-components';

import { Select } from '@/ui/Select';
import { Button } from '@/ui/Button';

enum SelectOptions {
  AddLearners = 'addLearners',
  AddTeams = 'addTeams',
}

const OptionStyled = styled.div`
  padding: 10px 0;
  display: flex;
  flex-direction: column;
`;

const OptionTitleStyled = styled.div`
  ${(p) => p.theme.typography.body3};
  color: ${(p) => p.theme.tones.neutral[10]};
`;

const OptionSubtitleStyled = styled.p`
  ${(p) => p.theme.typography.caption};
  color: ${(p) => p.theme.colors.neutral.outline2};
`;

type JourneyInsightsTabsParticipantsAddingButtonProps = {
  openAddParticipantsModal: VoidFunction;
  openAddTeamsModal: VoidFunction;
};

export const JourneyInsightsTabsParticipantsAddingButton = ({
  openAddParticipantsModal,
  openAddTeamsModal,
}: JourneyInsightsTabsParticipantsAddingButtonProps): React.ReactElement => {
  const handleChange = (value: string | string[]) => {
    if (value === SelectOptions.AddLearners) {
      openAddParticipantsModal();
    } else if (value === SelectOptions.AddTeams) {
      openAddTeamsModal();
    }
  };

  return (
    <>
      <Select onChange={handleChange} value={''}>
        <Select.Header>
          {({ toggleShowOptions }) => (
            <Button variant="primary" onClick={toggleShowOptions}>
              Add learners
            </Button>
          )}
        </Select.Header>
        <Select.List forcedPosition="bottom-left">
          <Select.Option multiline value={SelectOptions.AddLearners}>
            <OptionStyled>
              <OptionTitleStyled>Add learners</OptionTitleStyled>
              <OptionSubtitleStyled>Select and add individual learners</OptionSubtitleStyled>
            </OptionStyled>
          </Select.Option>
          <Select.Option multiline value={SelectOptions.AddTeams}>
            <OptionStyled>
              <OptionTitleStyled>Add teams</OptionTitleStyled>
              <OptionSubtitleStyled>Select teams to add multiple learners</OptionSubtitleStyled>
            </OptionStyled>
          </Select.Option>
        </Select.List>
      </Select>
    </>
  );
};
